import _classCallCheck from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import HTMLMaskElement from './html-mask-element.js';
import IMask from '../core/holder.js';
import './mask-element.js';

/** Bridge between InputElement and {@link Masked} */
var HTMLInputMaskElement = /*#__PURE__*/function (_HTMLMaskElement) {
  _inherits(HTMLInputMaskElement, _HTMLMaskElement);
  var _super = _createSuper(HTMLInputMaskElement);
  /** InputElement to use mask on */

  function HTMLInputMaskElement(input) {
    var _this;
    _classCallCheck(this, HTMLInputMaskElement);
    _this = _super.call(this, input);
    _this.input = input;
    _this._handlers = {};
    return _this;
  }

  /** Returns InputElement selection start */
  _createClass(HTMLInputMaskElement, [{
    key: "_unsafeSelectionStart",
    get: function get() {
      return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }

    /** Returns InputElement selection end */
  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      return this.input.selectionEnd;
    }

    /** Sets InputElement selection */
  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
  }, {
    key: "value",
    get: function get() {
      return this.input.value;
    },
    set: function set(value) {
      this.input.value = value;
    }
  }]);
  return HTMLInputMaskElement;
}(HTMLMaskElement);
IMask.HTMLMaskElement = HTMLMaskElement;
export { HTMLInputMaskElement as default };